import { useEffect, type RefObject } from "react";

type ResizeObserverCallback = (entries: ResizeObserverEntry[]) => void;

/**
 * Custom hook to observe element resize events
 * @param ref - React ref to the element to observe
 * @param callback - Callback function called on resize
 */
export const useResizeObserver = (
  ref: RefObject<HTMLElement>,
  callback: ResizeObserverCallback
): void => {
  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    // Create ResizeObserver instance
    const observer = new ResizeObserver((entries) => {
      if (entries.length > 0) {
        callback(entries);
      }
    });

    // Start observing
    observer.observe(element);

    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, [ref, callback]);
};
